.container {
  display: flex;
  gap: 2rem;
  padding: 1rem;
  height: 100%;
  overflow-y: auto;
}

.section {
  flex: 1;
  min-width: 150px;
}

.header {
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--text-muted);
  margin-bottom: 0.5rem;
}

.list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.listItem {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.25rem 0.5rem;
  background: var(--bg-elevated);
  border-radius: 4px;
}

.label {
  font-family: var(--font-mono);
  font-size: 0.85rem;
}

.button {
  border: none;
  border-radius: 4px;
  padding: 2px 8px;
  font-size: 0.75rem;
  font-weight: bold;
  cursor: pointer;
}

.indicator {
  border-radius: 4px;
  padding: 2px 8px;
  font-size: 0.75rem;
  font-weight: bold;
}

.on {
  background: var(--color-success);
  color: white;
}

.off {
  background: var(--bg-sunken);
  color: var(--text-muted);
}

.stats {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  font-size: 0.85rem;
  font-family: var(--font-mono);
}
